import React from "react";
import { useI18n } from "@/lib/i18n";
import Seo from "@/components/Seo";

export default function DppExplainer() {
  const { t, locale } = useI18n();
  return (
    <>
      <Seo
        title={t.section_dpp_title}
        description={t.section_dpp_body}
        canonicalPath="/dpp-explainer"
        locale={locale}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Article",
          headline: t.section_dpp_title,
          articleBody: t.section_dpp_body,
        }}
      />
      <div className="bp-container py-16 max-w-3xl">
        <div className="uppercase text-xs tracking-[0.3em] mb-4" style={{ color: "var(--bp-text-muted)" }}>Regulation EU 2024/1781 · ESPR</div>
        <h1 className="font-serif text-4xl md:text-5xl mb-6">{t.section_dpp_title}</h1>
        <div className="space-y-5 text-base md:text-lg leading-relaxed" style={{ color: "var(--bp-text-secondary)" }}>
          <p>{t.section_dpp_body}</p>
          <p><b>BrandPassport is an index - we do not issue Digital Product Passports.</b> {t.section_dpp_clarify}</p>
          <p>
            Under ESPR, most physical products placed on the EU market will need to carry a Digital Product Passport (DPP): a machine-readable record of product identity, material composition, origin, repairability, environmental footprint, end-of-life pathways, and any relevant certifications. The passport is accessed via a data carrier (QR, RFID or similar) attached to or embedded in the product.
          </p>
          <p>
            Product categories are covered by successive delegated acts. Textiles and apparel are among the first with rules expected effective in 2027. Other categories will follow according to the ESPR working plan.
          </p>
          <p>
            BrandPassport tracks what brands publish today across the seven categories the DPP will require. This is a factual index of publicly available information — it does not measure compliance and it does not issue passports.
          </p>
        </div>
        <div className="mt-10 p-6 bg-white border-l-4 border-black">
          <p className="font-medium">{t.section_dpp_clarify}</p>
        </div>
      </div>
    </>
  );
}
